import { Box, Stack, Button, Typography, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from "@/theme/colorUtils";

export const Root = styled(Box)(() => ({
  width: "100%",
  maxWidth: "500px",
  margin: "0 auto",
  height: "100vh",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "16px",
  boxSizing: "border-box",
  gap: "80px",
}));

export const ContentsBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "80px",
}));

export const ButtonBox = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
}));

export const ButtonStyle = styled(Button)(() => ({
  "&.MuiButtonBase-root": {
    position: "relative",
    width: "100%",
    height: 48,
    padding: "0px 16px",
    boxSizing: "border-box",
    borderRadius: 8,
    marginBottom: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& p": {
      fontSize: "0.875rem",
      fontWeight: 400,
      color: "#fff",
      textTransform: "none",
    },
    "&:after": {
      content: "''",
    },
  },
}));

export const NoeButtonStyle = styled(ButtonStyle)(() => ({
  "&.MuiButtonBase-root": {
    border: "1px solid #FF993C",
    background: "#FF993C",
    "&:hover": {
      background: "#FF993C",
    },
    "&:before": {
      width: 15,
      height: 18,
    },
  },
}));

export const GoogleButtonStyle = styled(ButtonStyle)(() => ({
  "&.MuiButtonBase-root": {
    border: "1px solid #c9c9ca",
    background: "#fff",
    "&:hover": {
      background: "#fff",
    },
    "& p": {
      color: "#909195",
    },
    "&:after": {
      width: 20,
      height: 20,
    },
  },
}));

export const AppleButtonStyle = styled(ButtonStyle)(() => ({
  "&.MuiButtonBase-root": {
    border: "1px solid #212121",
    background: "#212121",
    "&:hover": {
      background: "#212121",
    },
    "&:after": {
      width: 14,
      height: 18,
    },
  },
}));

export const KakaoButtonStyle = styled(ButtonStyle)(() => ({
  "&.MuiButtonBase-root": {
    border: "1px solid #FEE500",
    background: "#FEE500",
    "&:hover": {
      background: "#FEE500",
    },
    "& p": {
      color: "#333",
    },
    "&:after": {
      width: 14,
      height: 18,
    },
  },
}));

export const NaverButtonStyle = styled(ButtonStyle)(() => ({
  "&.MuiButtonBase-root": {
    border: "1px solid #03C75A",
    background: "#03C75A",
    marginBottom: 0,
    "&:hover": {
      background: "#03C75A",
    },
    "&:after": {
      width: 14,
      height: 18,
    },
  },
}));

export const RecentlyBox = styled(Box)(() => ({
  position:'absolute',
  right:0,
  top:-5,
  fontSize:'0.75rem',
  color:'#333',
  padding:'4px 12px',
  background: '#FDD751',
  backgroundSize: "container",
  backgroundRepeat: "no-repeat",
  borderRadius:'100px'
}));

export const TitleTextStyle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#FDD751",
  },
}));

export const TextStyle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontWeight: 400,
    color: "#333",
    marginTop: 16,
    textAlign: "center",
  },
}));

// 최초 가입 - 약관동의
export const SignInRoot = styled(Stack)(() => ({
  width: "100%",
  height: "100vh",
}));

export const SignInContentsBox = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  padding: "24px 16px",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: 24,
  "&.modify":{
    height: "calc(100vh - 142px)",
  },
  "&.Terms":{
    justifyContent:'flex-end'
  },
  "&.ConfirmRevised":{
    justifyContent:'flex-start',
    height: "100%",
    gap: 24
  }
}));

export const SignInProgressBarContainer = styled(Box)(() => ({
  width: "100%",
  padding: 0,
  boxSizing: "border-box",
  marginTop: 0,
}));

export const SignInProgressTrack = styled(Box)(() => ({
  width: "100%",
  height: 6,
  borderRadius: 0,
  backgroundColor: "#FFFCF0",
  overflow: "hidden",
}));

export const SignInProgressFill = styled(Box, {
  shouldForwardProp: (prop) => prop !== "percent",
})(({ percent }) => ({
  width: `${Math.max(0, Math.min(100, Number(percent) || 0))}%`,
  height: "100%",
  borderRadius: 100,
  backgroundColor: "#FDD751",
  transition: "width 200ms ease",
}));

export const InfoBox = styled(Stack)(() => ({
  width: "100%",
  boxSizing: "border-box",
  alignItems:'center',
  gap:16,
  flex: 1
}));


export const TextBox = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const SignInTitleTextStyle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#212121",
    marginBottom: 8,
  },
}));

export const SignInTextStyle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontWeight: 400,
    color: "#333",
    lineHeight: "19.6px",
    textAlign: "left",
  },
}));


export const ProfileImage = styled('div')({
  width: '120px',
  height: '120px',
  overflow:'hidden',
  padding:'8px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  backgroundColor: '#f2f2f2',
  position: 'relative',
});

// MUI TextField (다른 화면에서 사용)
export const InputField = styled(TextField)({
  width: "100%",
  "& .MuiFormHelperText-root": {
    marginTop: "4px",
    marginLeft: 0,
    marginRight: 0,
  },
});

// 일반 input (SignInInfo 시안용)
export const PlainInputWrapper = styled(Box)(() => ({
  width: "100%",
  position: "relative",
}));

export const PlainInputField = styled("input", {
  shouldForwardProp: (prop) => prop !== "hasError",
})(({ hasError }) => ({
  width: "100%",
  height: 40,
  boxSizing: "border-box",
  padding: "0 14px",
  borderRadius: 4,
  border: `1px solid ${hasError ? "#FE536B" : "#E5E7EB"}`,
  outline: "none",
  fontSize: "1rem",
  lineHeight: "40px",
  color: "#212121",
  backgroundColor: "#FFFFFF",
  transition: "border-color 120ms ease, box-shadow 120ms ease",
  "::placeholder": {
    color: "#B8B8B8",
  },
  ":focus": {
    borderColor: "#FDD751",
    boxShadow: "0 0 0 3px rgba(253, 215, 81, 0.25)",
  },
  ":disabled": {
    backgroundColor: "#F6F7F9",
    color: "#909195",
    cursor: "not-allowed",
  },
}));

export const PlainInputRightSlot = styled(Box)(() => ({
  position: "absolute",
  right: 8,
  top: "50%",
  transform: "translateY(-50%)",
  pointerEvents: "none",
}));

export const InputGroup = styled(Box)(() => ({
  width: "100%",
}));

export const InputLabelText = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "0.875rem",
    color: "#8F8F8F",
    marginBottom: 4,
  },
}));


export const InputLabelRequired = styled("span")(() => ({
  color: "#FE536B",
}));

export const GenderButtonGroup = styled(Box)(() => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 8,
}));

export const GenderButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ isSelected }) => ({
  "&.MuiButtonBase-root": {
    height: 40,
    borderRadius: 4,
    border: isSelected ? "1px solid #FDD751" : "1px solid #E5E7EB",
    backgroundColor: isSelected ? "#F5F5F5" : "#FFFFFF",
    color: isSelected ? "#212121" : "#8f8f8f",
    fontSize: "1rem",
    fontWeight: 500,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

}));

export const NoteText = styled(Typography)({
  fontSize: '12px',
  color: '#888',
  textAlign: 'left',
  width: '100%',
  marginBottom: '12px',
  '& b':{
    color:'#FE536B'
  }
});

export const ErrorText = styled(Typography)({
  fontSize: "0.75rem",
  color: "#FE536B",
  textAlign: "left",
  width: "100%",
  marginTop: "4px",
});

export const ButtonContainer = styled(Stack)(() => ({
  width: "100%",
  boxSizing: "border-box",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
}));
